module.exports = __webpack_public_path__ + "img/format-image4.288d3310.png";